var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowSkipIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow/Skip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M13.102 8.33466C13.102 8.29633 13.1053 8.25799 13.1053 8.21966C13.1053 7.12143 12.7797 6.04787 12.1695 5.13473C11.5594 4.22159 10.6921 3.50989 9.67751 3.08963C8.66287 2.66938 7.5464 2.55943 6.46928 2.77371C5.39215 2.98799 4.40276 3.51686 3.62622 4.29345C2.84968 5.07004 2.32087 6.05946 2.10665 7.13659C1.89244 8.21373 2.00245 9.33019 2.42277 10.3448C2.84309 11.3594 3.55484 12.2266 4.46802 12.8367C5.38119 13.4468 6.45477 13.7724 7.553 13.7723V13.1057C6.58663 13.1057 5.64194 12.8192 4.8384 12.2824C4.03485 11.7455 3.40855 10.9825 3.03869 10.0897C2.66883 9.19689 2.57202 8.21447 2.76051 7.26665C2.949 6.31884 3.41432 5.44821 4.09763 4.76486C4.78093 4.0815 5.65154 3.61612 6.59934 3.42757C7.54714 3.23901 8.52956 3.33575 9.42238 3.70555C10.3152 4.07535 11.0783 4.7016 11.6152 5.50511C12.1521 6.30862 12.4387 7.25329 12.4387 8.21966C12.4387 8.25799 12.433 8.29633 12.432 8.33466H10.9583L12.729 11.2327L14.5 8.33466H13.102Z",
    fill: "black"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowSkipIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Arrow_Skip_icon.df6d1c5117d424810ed524d5926d300a.svg";